/** @jsx jsx */
import { jsx, css } from '@compiled/react';
import Tooltip from '@atlaskit/tooltip';
import { token } from '@atlaskit/tokens';
import Anchor from '@atlaskit/primitives/anchor';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const SlackIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
		<g clipPath="url(#clip0_672_84381)">
			<path
				d="M5.00277 9.23771C5.00277 9.81815 4.5286 10.2923 3.94816 10.2923C3.36772 10.2923 2.89355 9.81815 2.89355 9.23771C2.89355 8.65727 3.36772 8.18311 3.94816 8.18311H5.00277V9.23771Z"
				fill="#E01E5A"
			/>
			<path
				d="M5.53418 9.23771C5.53418 8.65727 6.00835 8.18311 6.58879 8.18311C7.16924 8.18311 7.6434 8.65727 7.6434 9.23771V11.8783C7.6434 12.4588 7.16924 12.9329 6.58879 12.9329C6.00835 12.9329 5.53418 12.4588 5.53418 11.8783V9.23771Z"
				fill="#E01E5A"
			/>
			<path
				d="M6.58879 5.00277C6.00835 5.00277 5.53418 4.5286 5.53418 3.94816C5.53418 3.36772 6.00835 2.89355 6.58879 2.89355C7.16924 2.89355 7.6434 3.36772 7.6434 3.94816V5.00277H6.58879Z"
				fill="#36C5F0"
			/>
			<path
				d="M6.58878 5.53418C7.16922 5.53418 7.64338 6.00834 7.64338 6.58878C7.64338 7.16922 7.16922 7.64338 6.58878 7.64338H3.94816C3.36772 7.64338 2.89355 7.16922 2.89355 6.58878C2.89355 6.00834 3.36772 5.53418 3.94816 5.53418H6.58878Z"
				fill="#36C5F0"
			/>
			<path
				d="M10.8232 6.58878C10.8232 6.00834 11.2974 5.53418 11.8778 5.53418C12.4583 5.53418 12.9324 6.00834 12.9324 6.58878C12.9324 7.16922 12.4583 7.64338 11.8778 7.64338H10.8232V6.58878Z"
				fill="#2EB67D"
			/>
			<path
				d="M10.2919 6.58878C10.2919 7.16922 9.81768 7.64338 9.23723 7.64338C8.65679 7.64338 8.18262 7.16922 8.18262 6.58878V3.94816C8.18262 3.36772 8.65679 2.89355 9.23723 2.89355C9.81768 2.89355 10.2919 3.36772 10.2919 3.94816V6.58878Z"
				fill="#2EB67D"
			/>
			<path
				d="M9.23723 10.8237C9.81768 10.8237 10.2919 11.2979 10.2919 11.8783C10.2919 12.4588 9.81768 12.9329 9.23723 12.9329C8.65679 12.9329 8.18262 12.4588 8.18262 11.8783V10.8237H9.23723Z"
				fill="#ECB22E"
			/>
			<path
				d="M9.23722 10.2923C8.65678 10.2923 8.18262 9.81815 8.18262 9.23771C8.18262 8.65727 8.65678 8.18311 9.23722 8.18311H11.8778C12.4583 8.18311 12.9324 8.65727 12.9324 9.23771C12.9324 9.81815 12.4583 10.2923 11.8778 10.2923H9.23722Z"
				fill="#ECB22E"
			/>
		</g>
		<defs>
			<clipPath id="clip0_672_84381">
				<rect width="10.6667" height="10.6667" fill="none" transform="translate(2.6665 2.66675)" />
			</clipPath>
		</defs>
	</svg>
);

export type Props = {
	href?: string;
};

export const SlackTooltip = ({ href }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={formatMessage(messages.content)}>
			{(tooltipProps) => (
				<span css={tooltipContainer}>
					<Anchor
						{...tooltipProps}
						href={href ?? 'https://www.atlassian.com/'}
						target="_blank"
						rel="noopener noreferrer"
						testId="issue-comment-base.ui.comment.custom-comment.slack-tooltip.link"
						aria-label={formatMessage(messages.icon)}
					>
						<SlackIcon />
					</Anchor>
				</span>
			)}
		</Tooltip>
	);
};

const tooltipContainer = css({
	height: token('space.200'),
	width: token('space.200'),
	marginLeft: token('space.050'),
});
